module.exports = __webpack_public_path__ + "img/gitlab.62562b31.png";